/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CommonPagingPagingSettings {
    limit?: number;
    offset?: number;
    sortColumn?: string;
    /**
     * 0 = Ascending, 1 = Descending
     */
    sortOrder?: CommonPagingPagingSettings.SortOrderEnum;
}
export namespace CommonPagingPagingSettings {
    export type SortOrderEnum = 0 | 1;
    export const SortOrderEnum = {
        Ascending: 0 as SortOrderEnum,
        Descending: 1 as SortOrderEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/commonPagingPagingSettings.ts